import React, {useEffect} from 'react';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import {Helmet} from "react-helmet";
import ScrollAnimation from 'react-animate-on-scroll';

import FullRow from '../components/FullRow';

import dentalOffices from '../assets/images/dentalOffices.jpg';
import medicalOffices from '../assets/images/medicalOffices.jpg';
import optometryOffices from '../assets/images/optometryOffices.jpg';
import chiropracticOffices from '../assets/images/chiropracticOffices.jpg';
import urgentCareOffices from '../assets/images/urgentCareOffices.jpg';
import pharmacyOutlets from '../assets/images/pharmacyOutlets.jpg';
import clinicsAndHospitals from '../assets/images/clinicsAndHospitals.jpg';
import imageryAndLaboratoryOffices from '../assets/images/imageryAndLaboratoryOffices.jpg';

const useStyles = makeStyles(theme => ({
    container: {
        paddingTop: "100px",
        paddingLeft: "15%",
        paddingRight: "15%",
        backgroundColor: theme.palette.background.bg1,
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "5%",
            paddingRight: "5%",
        },
    },
    box: {
        "&:hover": {
            "& h2": {
                color: theme.palette.primary.main,
                letterSpacing: 1,
            },
            "& img": {
                opacity: 0.5
            }
        },
        [theme.breakpoints.down("sm")]: {
            marginBottom: "10px"
        },
    },
    serviceText: {
        marginTop: "10px",
        lineHeight: 1.5,
        paddingLeft: "10px",
        paddingRight: "10px",
        marginBottom: "10px",
        letterSpacing: 0,
        fontSize: "13px",
        transition: "0.5s"
    },
    subtitle: {
        marginBottom: "1em"
    },
    serviceContainer: {
        marginTop: "5em",
        marginBottom: "5em",
        overflowX: "hidden",
        [theme.breakpoints.down("sm")]: {
            padding: 25
        }
    },
}))


export default function Services(props) {
    const classes = useStyles();
    const theme = useTheme();
    const matchesMD = useMediaQuery(theme.breakpoints.down("md"));
    const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));
    const matchesXS = useMediaQuery(theme.breakpoints.down("xs"));

    const setMenuSelected = props.setMenuSelected;
    useEffect(() => {
        if (setMenuSelected) {
            window.scrollTo(0, 0);
            setMenuSelected("services");
        }

    }, []);

    return (
        <React.Fragment>
            <Helmet>
                <title>Services - remodeling, house urgentCareOffices & house plans</title>
                <meta name="description" key="description"
                      content="We Offer dental offices, medical offices, optometry offices, chiropractic offices, Urgent care facilities, pharmacy outlets, clinics and hospitals, imagery and laboratory offices"/>
                <meta name="description" key="description"
                      content="We Offer dental offices, medical offices, optometry offices, chiropractic offices, Urgent care facilities, pharmacy outlets, clinics and hospitals, imagery and laboratory offices"/>
            </Helmet>

            <Grid container direction="column" className={classes.container} id="services">

                <Grid item>
                    <Typography component="h1" variant="h2" gutterBottom>SERVICES</Typography>
                </Grid>
                <Grid item>
                    <Typography component="h2" variant="h1" paragraph>What We Offer</Typography>
                </Grid>

                <Grid item>
                    <Typography component="p" variant="body1">
                        Our services include free; site search, site visit, site selection, space planning, preparing
                        construction cost proposal and estimating construction completion time.
                        Our team of professionals will evaluate the site or space to determine the most cost-effective
                        solution for the entire project.
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography component="p" variant="body1" paragraph>
                        Our interior designers create attractive medical or dental environments that combine pleasant
                        ambiance with cost effective, innovative yet practical urgentCareOffices solutions in use of
                        materials,
                        furnishings, finishes and lightings.
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography component="p" variant="body1" paragraph>
                        Our services include but not limited to new construction, renovation, Tenant improvement of
                        dental and medical offices, Chiropractic offices, Urgent care facilities, Optometry offices,
                        Pharmacy outlets, Clinics and hospitals, Imagery and laboratory offices, emergency care
                        facilities, surgery centers.
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography component="p" variant="body1" paragraph>
                        We coordinate and work hand in hand with leading equipment providers and their representative in
                        the area to better serve our mutual clients.
                        We are experienced in SBA Construction and Loan requirements. Fund control, bank supervised
                        schedules.
                    </Typography>
                </Grid>
            </Grid>


            <FullRow image={dentalOffices} altImage={"Dental offices"} dir={0} imageW={400}
                     content={{
                         title: "Dental offices",
                         subtitle: "Explore our portfolio of Dental offices projects.",
                         url: "Dental"
                     }}
            />

            <FullRow image={optometryOffices} altImage={"Optometry offices"} dir={1} imageW={400}
                     content={{
                         title: "Optometry offices",
                         subtitle: "Explore our portfolio of Optometry offices projects.",
                         url: "Optometry"
                     }}
            />

            <FullRow image={chiropracticOffices} altImage={"Chiropractic offices"} dir={0} imageW={400}
                     content={{
                         title: "Chiropractic offices",
                         subtitle: "Explore our portfolio of Chiropractic offices projects.",
                         url: "Chiropractic"
                     }}
            />

            <FullRow image={urgentCareOffices} altImage={"Urgent care facilities"} dir={1} imageW={400}
                     content={{
                         title: "Urgent care facilities",
                         subtitle: "Explore our portfolio of Urgent care facilities projects.",
                         url: "Urgent"
                     }}
            />

            <FullRow image={pharmacyOutlets} altImage={"Pharmacy outlets"} dir={0} imageW={400}
                     content={{
                         title: "Pharmacy  outlets",
                         subtitle: "Explore our portfolio of Pharmacy outlets projects.",
                         url: "Pharmacy"
                     }}
            />


            <FullRow image={medicalOffices} altImage={"Medical offices"} dir={1} imageW={400}
                     content={{
                         title: "Medical offices",
                         subtitle: "Explore our portfolio of Medical offices projects.",
                         url: "Medical"
                     }}
            />

            <FullRow image={clinicsAndHospitals} altImage={"Clinics and hospitals"} dir={0} imageW={400}
                     content={{
                         title: "Clinics and hospitals",
                         subtitle: "Explore our portfolio of Clinics and hospitals projects.",
                         url: "Clinics"
                     }}
            />

            <FullRow image={imageryAndLaboratoryOffices} altImage={"Imagery and laboratory offices"} dir={1}
                     imageW={400}
                     content={{
                         title: "Imagery and laboratory offices",
                         subtitle: "Explore our portfolio of Imagery and laboratory offices projects.",
                         url: "Imagery"
                     }}
            />


        </React.Fragment>

    );
}
